<template>
  <breeze-authenticated-layout>
    <div class="row p-3">
      <div class="col-12">
        <h1>Delete Your Nuvita Account?</h1>

        <breeze-button
            class="btn btn-primary"
            v-on:click="deleteAccountWarning()">
          Yes, delete my account
        </breeze-button>
      </div>
    </div>
  </breeze-authenticated-layout>
</template>

<script>
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import BreezeButton from '@/Components/Elements/Button'
import UserBasic from '@/Components/Users/forms/user-basic'
import UserAddress from '@/Components/Users/forms/user-address'
import UserOrganization from '@/Components/Users/forms/user-organization'
import UserPassword from '@/Components/Users/forms/user-password'
import UserAvatar from '@/Components/Users/forms/user-avatar'
import UserMessages from '@/Components/Users/forms/user-messages'
import UserSubscribe from '@/Components/Users/forms/user-subscribe'
import UserOptions from '@/Components/Users/forms/user-options'
import ConfirmDelete from '@/Components/ZElements/ConfirmDialog'
import {mapActions, mapGetters} from "vuex";

export default {
  ...mapActions('users', ['saveUser', 'deleteUser']),
  components: {
    BreezeButton,
    BreezeAuthenticatedLayout,
    UserBasic,
    UserAddress,
    UserOrganization,
    UserPassword,
    UserAvatar,
    UserMessages,
    UserSubscribe,
    UserOptions,
    ConfirmDelete,
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('users', ['user']),
    ...mapGetters('users', ['token', 'profile', 'isAllowed']),
  },
  methods: {
    ...mapActions('users', ['saveUser', 'deleteUser']),
    deleteAccountWarning() {
      if (confirm("Warning!\n\nThis will permanently delete your Nuvita account and all associated data.")) {
        console.log("Deleting account", this.profile)
        this.performDelete()
      }
    },
    async performDelete() {
      console.log('Deleting', this.profile)
      await this.deleteUser(this.profile.id)
      window.location = 'login'
      this.$emit('deleted')
    },
  }
}
</script>
